/**
 * "Start in Touch Mode" preference — when set, the Electron app boots straight
 * into the touch-panel flow (`/pair` → panel mode) instead of the launcher.
 * Stored in localStorage; owned by the app settings modal, consumed by the
 * launcher on mount.
 */
export const START_IN_TOUCH_MODE_KEY = 'otto_start_in_touch_mode';

export function readStartInTouchMode(): boolean {
  try {
    return localStorage.getItem(START_IN_TOUCH_MODE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writeStartInTouchMode(enabled: boolean): void {
  try {
    localStorage.setItem(START_IN_TOUCH_MODE_KEY, enabled ? 'true' : 'false');
  } catch {
    // localStorage unavailable — preference stays session-only
  }
}
